import React from "react";
import { Outlet } from "react-router-dom";
import PageFooter from "../../Components/Footer";
import PageHeader from "../../Components/Header";
import { useAuth } from "../../contexts/AuthContext";

const Layout = () => {
  const { isAuthenticated } = useAuth();

  return (
    <div className={`main-app-wrapper ${isAuthenticated ? "authenticated-shell" : "public-shell"}`}>
      <div className="app-backdrop" aria-hidden="true">
        <span className="backdrop-orb orb-primary" />
        <span className="backdrop-orb orb-secondary" />
        <span className="backdrop-grid" />
      </div>
      <PageHeader />
      <div className="app-content-shell">
        <Outlet />
      </div>
      <PageFooter compact={!isAuthenticated} />
    </div>
  );
};

export default Layout;
